import React, { useEffect, useState } from "react";
import classes from "./ClinicsList.module.css";

//components
import ClinicCard from "./ClinicCard/ClinicCard";

//libraries
import axios from "axios";

//This component gets the Clinics information from the database and displays them in ClinicCards

const ClinicsList = (props) => {
  
  const [clinics, setClinics] = useState([]);//state to store the data fetched
  const [loading, setLoading] = useState("Loading...");//Stores the message displayed instead of the data (loading or Error)

  useEffect(() => {
    //axios fetches data from API
    axios
      .get("http://portal.lwah.org.lb:8080/PHPApis/ServListDoctorsAdv.php")
      .then((response) => {
        setClinics(response.data);
      })
      .catch((error) => {
        console.log(error);
        //sets the msg displayed instead of the data to Error
        setLoading("ERROR! TRY AGAIN LATER")
      });
  }, []);
  return (
    <div className={classes.container}>
      <div className={classes.column}>
        <div className={classes.bigTitle}>
          العيادات المتخصصة
        </div>
        <div className={classes.info}>
          اضغط على الطبيب في العيادة المختصة لحجز موعد
        </div>
      </div>
      <div className={classes.list}>
        
      {
        //maps the array of clinics into ClinicCards
        (clinics.length > 0)?
            clinics.map((Clinic) => {
                if (Clinic.Doctors.length != 0){
                    return <ClinicCard Clinic={Clinic} key={Clinic.ServId} />;
                }
            })
        :<div className={classes.Loading}>
            {loading}
        </div>
        }
      </div>
    </div>
  );
};
export default ClinicsList;
